<div class="help-page">
  <div class="contact-details">
    <p class="contact-title">Contact details</p>
    <div class="context">
      <div class="context-title">
        <p class="label">Call:</p>
        <p class="value">{{ nadaPhone }}</p>
      </div>
      <div class="context-email">
        <p class="label">Email:</p>
        <p class="value">{{ nadaEmail }}</p>
      </div>
    </div>
  </div>
  <div class="email-container">
    <p class="email-title">Send us an email</p>
    <div class="email-input">
      <input
        type="text"
        class="email-subject"
        placeholder="Subject"
        [(ngModel)]="subject"
      />
      <textarea
        class="email-message"
        placeholder="Type your message here..."
        [(ngModel)]="message"
      ></textarea>
      @if (errorMessage) {
        <p class="email-error-message">{{ errorMessage }}</p>
      }
      @if (successMessage) {
        <p class="email-success-message">{{ successMessage }}</p>
      }
      <button
        class="email-send"
        (click)="onSendEmail()"
        [disabled]="isSendingMail"
      >
        {{ sendButtonStatus }}
      </button>
    </div>
  </div>
</div>
